import type { AdsPageLineItem } from '../../../../common/AdForm/types';
import { assetTypes } from '../../../../configs';
import type { Asset2Extended } from '../../../../models';
import { getCountryCodesFromAsset } from './getCountryCodesFromAsset';
import { getCountryCodesFromLineItem } from './getCountryCodesFromLineItem';

export type GatewayGoAssetCountryCodesInput = {
  displayCountryCodes: string[] | null;
  videoCountryCodes: string[] | null;
};

/**
 * Generates Display and Video input objects for GatewayGo creatives
 * @param lineItem Line Item for the Ad
 * @param assets List of Assets attached to the Ad's Creative
 * @returns Display and Video asset input objects, or null if no assets are provided
 */
export function buildGatewayAssetCountryCodesInput(
  lineItem?: AdsPageLineItem,
  assets?: Asset2Extended[]
): GatewayGoAssetCountryCodesInput {
  if (!assets?.length) return { displayCountryCodes: null, videoCountryCodes: null };

  const displayAsset = assets?.find((asset) => asset.subClass === assetTypes.DisplayAsset.key);
  const videoAsset = assets?.find((asset) => asset.subClass === assetTypes.VideoAsset.key);

  if (!displayAsset && !videoAsset) return { displayCountryCodes: null, videoCountryCodes: null };

  const displayCountryCodes = getCountryCodesFromAsset(displayAsset);
  const videoCountryCodes = getCountryCodesFromAsset(videoAsset);
  const lineItemCountryCodes = getCountryCodesFromLineItem(lineItem);

  return {
    displayCountryCodes: [...new Set([...displayCountryCodes, ...lineItemCountryCodes])],
    videoCountryCodes: [...new Set([...videoCountryCodes, ...lineItemCountryCodes])],
  };
}
